import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthorsPanel from '../components/DataDirectory/AuthorsPanel';
import PublishersPanel from '../components/DataDirectory/PublishersPanel';
import UserProposalsPanel from '../components/DataDirectory/UserProposalsPanel';
import GenresPanel from '../components/DataDirectory/GenresPanel';
import LinkingAssistant from '../components/DataDirectory/LinkingAssistant';

type Tab = 'authors' | 'publishers' | 'user_proposals' | 'genres' | 'translators' | 'original_authors';

export default function DataDirectory() {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<Tab>('authors');
  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'authors' || tab === 'publishers' || tab === 'user_proposals') setActiveTab(tab);
  }, [searchParams]);

  return (
    <div className="bg-[#F1EFE8] min-h-screen p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-[#085041] mb-6">Data Directory</h1>

        <div className="flex gap-4 mb-6 border-b border-gray-300 pb-2">
          <button
            className={`px-4 py-2 font-bold transition-colors ${activeTab === 'authors' ? 'text-[#085041] border-b-2 border-[#085041]' : 'text-gray-500 hover:text-gray-700'}`}
            onClick={() => setActiveTab('authors')}
          >
            Authors
          </button>
          <button
            className={`px-4 py-2 font-bold transition-colors ${activeTab === 'publishers' ? 'text-[#085041] border-b-2 border-[#085041]' : 'text-gray-500 hover:text-gray-700'}`}
            onClick={() => setActiveTab('publishers')}
          >
            Publishers
          </button>
          <button
            className={`px-4 py-2 font-bold transition-colors ${activeTab === 'user_proposals' ? 'text-[#085041] border-b-2 border-[#085041]' : 'text-gray-500 hover:text-gray-700'}`}
            onClick={() => setActiveTab('user_proposals')}
          >
            📨 User Proposals
          </button>
          <button
            className={`px-4 py-2 font-bold transition-colors ${activeTab === 'genres' ? 'text-[#085041] border-b-2 border-[#085041]' : 'text-gray-500 hover:text-gray-700'}`}
            onClick={() => setActiveTab('genres')}
          >
            Genres
          </button>
          <button
            className={`px-4 py-2 font-bold transition-colors ${activeTab === 'translators' ? 'text-[#085041] border-b-2 border-[#085041]' : 'text-gray-500 hover:text-gray-700'}`}
            onClick={() => setActiveTab('translators')}
          >
            🔤 Translators
          </button>
          <button
            className={`px-4 py-2 font-bold transition-colors ${activeTab === 'original_authors' ? 'text-[#085041] border-b-2 border-[#085041]' : 'text-gray-500 hover:text-gray-700'}`}
            onClick={() => setActiveTab('original_authors')}
          >
            📖 Original Authors
          </button>
        </div>

        <div className="mt-6">
          {activeTab === 'authors' && <AuthorsPanel />}
          {activeTab === 'publishers' && <PublishersPanel />}
          {activeTab === 'user_proposals' && <UserProposalsPanel />}
          {activeTab === 'genres' && <GenresPanel />}
          {activeTab === 'translators' && (
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Link Translators</h2>
              <p className="text-gray-500 mb-6 text-sm">Review and link translator records to books. General translator CRUD is handled under the Authors tab.</p>
              <LinkingAssistant entityType="translators" />
            </div>
          )}
          {activeTab === 'original_authors' && (
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Link Original Authors</h2>
              <p className="text-gray-500 mb-6 text-sm">Review and link original author records to books. General author CRUD is handled under the Authors tab.</p>
              <LinkingAssistant entityType="original_authors" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
